import {BankTarget} from '../types/mx/types';

export const CHANGE_PRICE_ACTION = {
    name: 'CHANGE_PRICE_ACTION',
    action: (price, error) => ({
        price, error,
        type: CHANGE_PRICE_ACTION.name
    })
};

export const CHANGE_DOWN_PAYMENT_ACTION = {
    name: 'CHANGE_DOWN_PAYMENT_ACTION',
    action: (downPayment, error) => ({
        downPayment, error,
        type: CHANGE_DOWN_PAYMENT_ACTION.name
    })
};

export const CHANGE_DOWN_PAYMENT_SIMULATOR_PROFILE_ACTION = {
    name: 'CHANGE_DOWN_PAYMENT_SIMULATOR_PROFILE_ACTION',
    action: (downPayment, error, profile) => ({
        downPayment, error, profile,
        type: CHANGE_DOWN_PAYMENT_SIMULATOR_PROFILE_ACTION.name
    })
};

export const CHANGE_DOWN_PAYMENT_AFTER_PRICE_ACTION = {
    name: 'CHANGE_DOWN_PAYMENT_AFTER_PRICE_ACTION',
    action: (downPayment, error) => ({
        downPayment, error,
        type: CHANGE_DOWN_PAYMENT_AFTER_PRICE_ACTION.name
    })
};

export const CALCULATE_QUOTAS_MX_ACTION = {
    name: 'CALCULATE_QUOTAS_MX_ACTION',
    action: (
        postalCode,
        version,
        year,
        hasInsurance,
        price,
        entry,
        profile: boolean = false,
        target: BankTarget = BankTarget.CREDITO_REAL
    ) => ({
        postalCode, version, year, hasInsurance, price, entry, profile, target,
        type: CALCULATE_QUOTAS_MX_ACTION.name
    })
};

export const GOT_QUOTAS_MX_ACTION = {
    name: 'GOT_QUOTAS_MX_ACTION',
    action: (quotas, failInsurance) => ({
        quotas, failInsurance,
        type: GOT_QUOTAS_MX_ACTION.name
    })
};

export const CLEAN_QUOTAS_MX_ACTION = {
    name: 'CLEAN_QUOTAS_MX_ACTION',
    action: (brandSelectedId = '', modelSelectedId = '', versionSelectedId = '') => ({
        brandSelectedId, modelSelectedId, versionSelectedId,
        type: CLEAN_QUOTAS_MX_ACTION.name
    })
};

export const HAS_INSURANCE_SELECTED_ACTION = {
    name: 'HAS_INSURANCE_SELECTED_ACTION',
    action: hasInsurance => ({
        hasInsurance,
        type: HAS_INSURANCE_SELECTED_ACTION.name
    })
};

export const HAS_INSURANCE_SELECTED_SIMULATOR_PROFILE_ACTION = {
    name: 'HAS_INSURANCE_SELECTED_SIMULATOR_PROFILE_ACTION',
    action: (hasInsurance, profile) => ({
        hasInsurance, profile,
        type: HAS_INSURANCE_SELECTED_SIMULATOR_PROFILE_ACTION.name
    })
};

export const GOT_SIMULATOR_PROFILE_MX_ACTION = {
    name: 'GOT_SIMULATOR_PROFILE_MX_ACTION',
    action: creditConditions => ({
        creditConditions,
        type: GOT_SIMULATOR_PROFILE_MX_ACTION.name
    })
};

export const MONTHLY_PAYMENT_SELECTED_ACTION = {
    name: 'MONTHLY_PAYMENT_SELECTED_ACTION',
    action: (monthlyPayment, error) => ({
        monthlyPayment, error,
        type: MONTHLY_PAYMENT_SELECTED_ACTION.name
    })
};

export const YEAR_SELECTED_ACTION = {
    name: 'YEAR_SELECTED_ACTION',
    action: (year, error) => ({
        year, error,
        type: YEAR_SELECTED_ACTION.name
    })
};

export const BRAND_SELECTED_ACTION = {
    name: 'BRAND_SELECTED_ACTION',
    action: (brand, error) => ({
        brand, error,
        type: BRAND_SELECTED_ACTION.name
    })
};

export const MODEL_SELECTED_ACTION = {
    name: 'MODEL_SELECTED_ACTION',
    action: (model, error) => ({
        model, error,
        type: MODEL_SELECTED_ACTION.name
    })
};

export const VERSION_SELECTED_ACTION = {
    name: 'VERSION_SELECTED_ACTION',
    action: (version, error) => ({
        version, error,
        type: VERSION_SELECTED_ACTION.name
    })
};

export const PROVINCE_SELECTED_ACTION = {
    name: 'PROVINCE_SELECTED_ACTION',
    action: (province, error) => ({
        province, error,
        type: PROVINCE_SELECTED_ACTION.name
    })
};

export const ASSEMBLY_COUNTRY_SELECTED_ACTION = {
    name: 'ASSEMBLY_COUNTRY_SELECTED_ACTION',
    action: (assemblyCountry, error) => ({
        assemblyCountry, error,
        type: ASSEMBLY_COUNTRY_SELECTED_ACTION.name
    })
};

export const CHANGE_POSTAL_CODE_ACTION = {
    name: 'CHANGE_POSTAL_CODE_ACTION',
    action: (postalCode, error) => ({
        postalCode, error,
        type: CHANGE_POSTAL_CODE_ACTION.name
    })
};

export const VALIDATE_POSTAL_CODE_ACTION = {
    name: 'VALIDATE_POSTAL_CODE_ACTION',
    action: (isValid = false) => ({
        isValid,
        type: VALIDATE_POSTAL_CODE_ACTION.name
    })
};
